/** Auto-derived from world-atlas countries-110m (numeric id → display name). */
export const TOPO_COUNTRY_BY_ID: Record<string, string> = {
  '004': 'Afghanistan',
  '008': 'Albania',
  '012': 'Algeria',
  '024': 'Angola',
  '010': 'Antarctica',
  '032': 'Argentina',
  '051': 'Armenia',
  '036': 'Australia',
  '040': 'Austria',
  '031': 'Azerbaijan',
  '044': 'Bahamas',
  '050': 'Bangladesh',
  '112': 'Belarus',
  '056': 'Belgium',
  '084': 'Belize',
  '204': 'Benin',
  '064': 'Bhutan',
  '068': 'Bolivia',
  '070': 'Bosnia and Herz.',
  '072': 'Botswana',
  '076': 'Brazil',
  '096': 'Brunei',
  '100': 'Bulgaria',
  '854': 'Burkina Faso',
  '108': 'Burundi',
  '116': 'Cambodia',
  '120': 'Cameroon',
  '124': 'Canada',
  '140': 'Central African Rep.',
  '148': 'Chad',
  '152': 'Chile',
  '156': 'China',
  '170': 'Colombia',
  '178': 'Congo',
  '188': 'Costa Rica',
  '191': 'Croatia',
  '192': 'Cuba',
  '196': 'Cyprus',
  '203': 'Czechia',
  '384': 'Côte d\'Ivoire',
  '180': 'Dem. Rep. Congo',
  '208': 'Denmark',
  '262': 'Djibouti',
  '214': 'Dominican Rep.',
  '218': 'Ecuador',
  '818': 'Egypt',
  '222': 'El Salvador',
  '226': 'Eq. Guinea',
  '232': 'Eritrea',
  '233': 'Estonia',
  '231': 'Ethiopia',
  '238': 'Falkland Is.',
  '242': 'Fiji',
  '246': 'Finland',
  '260': 'Fr. S. Antarctic Lands',
  '250': 'France',
  '266': 'Gabon',
  '270': 'Gambia',
  '268': 'Georgia',
  '276': 'Germany',
  '288': 'Ghana',
  '300': 'Greece',
  '304': 'Greenland',
  '320': 'Guatemala',
  '324': 'Guinea',
  '624': 'Guinea-Bissau',
  '328': 'Guyana',
  '332': 'Haiti',
  '340': 'Honduras',
  '348': 'Hungary',
  '352': 'Iceland',
  '356': 'India',
  '360': 'Indonesia',
  '364': 'Iran',
  '368': 'Iraq',
  '372': 'Ireland',
  '376': 'Israel',
  '380': 'Italy',
  '388': 'Jamaica',
  '392': 'Japan',
  '400': 'Jordan',
  '398': 'Kazakhstan',
  '404': 'Kenya',
  '414': 'Kuwait',
  '417': 'Kyrgyzstan',
  '418': 'Laos',
  '428': 'Latvia',
  '422': 'Lebanon',
  '426': 'Lesotho',
  '430': 'Liberia',
  '434': 'Libya',
  '440': 'Lithuania',
  '442': 'Luxembourg',
  '807': 'Macedonia',
  '450': 'Madagascar',
  '454': 'Malawi',
  '458': 'Malaysia',
  '466': 'Mali',
  '478': 'Mauritania',
  '484': 'Mexico',
  '498': 'Moldova',
  '496': 'Mongolia',
  '499': 'Montenegro',
  '504': 'Morocco',
  '508': 'Mozambique',
  '104': 'Myanmar',
  '516': 'Namibia',
  '524': 'Nepal',
  '528': 'Netherlands',
  '540': 'New Caledonia',
  '554': 'New Zealand',
  '558': 'Nicaragua',
  '562': 'Niger',
  '566': 'Nigeria',
  '408': 'North Korea',
  '578': 'Norway',
  '512': 'Oman',
  '586': 'Pakistan',
  '275': 'Palestine',
  '591': 'Panama',
  '598': 'Papua New Guinea',
  '600': 'Paraguay',
  '604': 'Peru',
  '608': 'Philippines',
  '616': 'Poland',
  '620': 'Portugal',
  '630': 'Puerto Rico',
  '634': 'Qatar',
  '642': 'Romania',
  '643': 'Russia',
  '646': 'Rwanda',
  '728': 'S. Sudan',
  '682': 'Saudi Arabia',
  '686': 'Senegal',
  '688': 'Serbia',
  '694': 'Sierra Leone',
  '703': 'Slovakia',
  '705': 'Slovenia',
  '090': 'Solomon Is.',
  '706': 'Somalia',
  '710': 'South Africa',
  '410': 'South Korea',
  '724': 'Spain',
  '144': 'Sri Lanka',
  '729': 'Sudan',
  '740': 'Suriname',
  '752': 'Sweden',
  '756': 'Switzerland',
  '760': 'Syria',
  '158': 'Taiwan',
  '762': 'Tajikistan',
  '834': 'Tanzania',
  '764': 'Thailand',
  '626': 'Timor-Leste',
  '768': 'Togo',
  '780': 'Trinidad and Tobago',
  '788': 'Tunisia',
  '792': 'Turkey',
  '795': 'Turkmenistan',
  '800': 'Uganda',
  '804': 'Ukraine',
  '784': 'United Arab Emirates',
  '826': 'United Kingdom',
  '840': 'United States of America',
  '858': 'Uruguay',
  '860': 'Uzbekistan',
  '548': 'Vanuatu',
  '862': 'Venezuela',
  '704': 'Vietnam',
  '732': 'W. Sahara',
  '887': 'Yemen',
  '894': 'Zambia',
  '716': 'Zimbabwe',
  '748': 'eSwatini',
};

export const COUNTRY_LABEL_TO_TOPO_ID: Record<string, string> = {
  'AE': '784',
  'Afghanistan': '004',
  'Albania': '008',
  'Algeria': '012',
  'Angola': '024',
  'Antarctica': '010',
  'AR': '032',
  'ARG': '032',
  'Argentina': '032',
  'Armenia': '051',
  'AT': '040',
  'AU': '036',
  'AUS': '036',
  'Australia': '036',
  'Austria': '040',
  'AUT': '040',
  'Azerbaijan': '031',
  'Bahamas': '044',
  'Bangladesh': '050',
  'BD': '050',
  'BE': '056',
  'BEL': '056',
  'Belarus': '112',
  'Belgium': '056',
  'Belize': '084',
  'Benin': '204',
  'BGD': '050',
  'Bhutan': '064',
  'Bolivia': '068',
  'Bosnia and Herz.': '070',
  'Botswana': '072',
  'BR': '076',
  'BRA': '076',
  'Brazil': '076',
  'Brunei': '096',
  'Bulgaria': '100',
  'Burkina Faso': '854',
  'Burundi': '108',
  'CA': '124',
  'Cambodia': '116',
  'Cameroon': '120',
  'CAN': '124',
  'Canada': '124',
  'Central African Rep.': '140',
  'CH': '756',
  'Chad': '148',
  'CHE': '756',
  'Chile': '152',
  'China': '156',
  'CHL': '152',
  'CHN': '156',
  'CL': '152',
  'CN': '156',
  'CO': '170',
  'COL': '170',
  'Colombia': '170',
  'Congo': '178',
  'Costa Rica': '188',
  'Croatia': '191',
  'Cuba': '192',
  'Cyprus': '196',
  'CZ': '203',
  'Czech Republic': '203',
  'Czechia': '203',
  'Côte d\'Ivoire': '384',
  'DE': '276',
  'Dem. Rep. Congo': '180',
  'Denmark': '208',
  'DEU': '276',
  'Djibouti': '262',
  'DK': '208',
  'DNK': '208',
  'Dominican Rep.': '214',
  'Ecuador': '218',
  'EG': '818',
  'EGY': '818',
  'Egypt': '818',
  'El Salvador': '222',
  'Eq. Guinea': '226',
  'Eritrea': '232',
  'ES': '724',
  'ESP': '724',
  'Estonia': '233',
  'eSwatini': '748',
  'ET': '231',
  'ETH': '231',
  'Ethiopia': '231',
  'Falkland Is.': '238',
  'FI': '246',
  'Fiji': '242',
  'FIN': '246',
  'Finland': '246',
  'FR': '250',
  'Fr. S. Antarctic Lands': '260',
  'FRA': '250',
  'France': '250',
  'Gabon': '266',
  'Gambia': '270',
  'GB': '826',
  'GBR': '826',
  'Georgia': '268',
  'Germany': '276',
  'GH': '288',
  'GHA': '288',
  'Ghana': '288',
  'GR': '300',
  'GRC': '300',
  'Greece': '300',
  'Greenland': '304',
  'Guatemala': '320',
  'Guinea': '324',
  'Guinea-Bissau': '624',
  'Guyana': '328',
  'Haiti': '332',
  'HK': '344',
  'HKG': '344',
  'Honduras': '340',
  'Hong Kong': '344',
  'HU': '348',
  'HUN': '348',
  'Hungary': '348',
  'Iceland': '352',
  'ID': '360',
  'IDN': '360',
  'IE': '372',
  'IL': '376',
  'IN': '356',
  'IND': '356',
  'India': '356',
  'Indonesia': '360',
  'Iran': '364',
  'Iraq': '368',
  'Ireland': '372',
  'IRL': '372',
  'ISR': '376',
  'Israel': '376',
  'IT': '380',
  'ITA': '380',
  'Italy': '380',
  'Jamaica': '388',
  'Japan': '392',
  'Jordan': '400',
  'JP': '392',
  'JPN': '392',
  'Kazakhstan': '398',
  'KE': '404',
  'KEN': '404',
  'Kenya': '404',
  'Korea, Republic of': '410',
  'KR': '410',
  'Kuwait': '414',
  'Kyrgyzstan': '417',
  'Laos': '418',
  'Latvia': '428',
  'Lebanon': '422',
  'Lesotho': '426',
  'Liberia': '430',
  'Libya': '434',
  'Lithuania': '440',
  'Luxembourg': '442',
  'MA': '504',
  'Macedonia': '807',
  'Madagascar': '450',
  'Malawi': '454',
  'Malaysia': '458',
  'Mali': '466',
  'MAR': '504',
  'Mauritania': '478',
  'MEX': '484',
  'Mexico': '484',
  'Moldova': '498',
  'Mongolia': '496',
  'Montenegro': '499',
  'Morocco': '504',
  'Mozambique': '508',
  'MX': '484',
  'MY': '458',
  'Myanmar': '104',
  'MYS': '458',
  'Namibia': '516',
  'Nepal': '524',
  'Netherlands': '528',
  'New Caledonia': '540',
  'New Zealand': '554',
  'NG': '566',
  'NGA': '566',
  'Nicaragua': '558',
  'Niger': '562',
  'Nigeria': '566',
  'NL': '528',
  'NLD': '528',
  'NO': '578',
  'NOR': '578',
  'North Korea': '408',
  'Norway': '578',
  'NZ': '554',
  'NZL': '554',
  'Oman': '512',
  'PAK': '586',
  'Pakistan': '586',
  'Palestine': '275',
  'Panama': '591',
  'Papua New Guinea': '598',
  'Paraguay': '600',
  'Peru': '604',
  'PH': '608',
  'Philippines': '608',
  'PHL': '608',
  'PK': '586',
  'PL': '616',
  'POL': '616',
  'Poland': '616',
  'Portugal': '620',
  'PRT': '620',
  'PT': '620',
  'Puerto Rico': '630',
  'Qatar': '634',
  'RO': '642',
  'Romania': '642',
  'ROU': '642',
  'RU': '643',
  'RUS': '643',
  'Russia': '643',
  'Russian Federation': '643',
  'Rwanda': '646',
  'S. Sudan': '728',
  'SA': '682',
  'SAU': '682',
  'Saudi Arabia': '682',
  'SE': '752',
  'Senegal': '686',
  'Serbia': '688',
  'SG': '702',
  'SGP': '702',
  'Sierra Leone': '694',
  'Singapore': '702',
  'Slovakia': '703',
  'Slovenia': '705',
  'Solomon Is.': '090',
  'Somalia': '706',
  'South Africa': '710',
  'South Korea': '410',
  'Spain': '724',
  'Sri Lanka': '144',
  'Sudan': '729',
  'Suriname': '740',
  'SWE': '752',
  'Sweden': '752',
  'Switzerland': '756',
  'Syria': '760',
  'Taiwan': '158',
  'Tajikistan': '762',
  'Tanzania': '834',
  'TH': '764',
  'THA': '764',
  'Thailand': '764',
  'Timor-Leste': '626',
  'Togo': '768',
  'TR': '792',
  'Trinidad and Tobago': '780',
  'Tunisia': '788',
  'TUR': '792',
  'Turkey': '792',
  'Turkmenistan': '795',
  'TW': '158',
  'TWN': '158',
  'UA': '804',
  'UAE': '784',
  'Uganda': '800',
  'UK': '826',
  'UKR': '804',
  'Ukraine': '804',
  'United Arab Emirates': '784',
  'United Kingdom': '826',
  'United States': '840',
  'United States of America': '840',
  'Uruguay': '858',
  'US': '840',
  'USA': '840',
  'Uzbekistan': '860',
  'Vanuatu': '548',
  'Venezuela': '862',
  'Vietnam': '704',
  'VN': '704',
  'VNM': '704',
  'W. Sahara': '732',
  'Yemen': '887',
  'ZA': '710',
  'ZAF': '710',
  'Zambia': '894',
  'Zimbabwe': '716',
};
